/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
// import Checkbox from 'antd/lib/checkbox';
import ConfigProvider from 'antd/lib/config-provider';
import Empty from 'antd/lib/empty';
import Table from 'antd/lib/table';
import Dropdown from 'antd/lib/dropdown';
// import Menu from 'antd/lib/menu';
// import notification from 'antd/lib/notification';
import { getEventsList } from '../../../../../../API'; // updateAlertResolutions
import { CustomResolutionModal } from '../../../CustomResolutionModal';
import { config } from '../../../../../../config';
import { Dropdown as PDropdown } from '../../../../../UI/Dropdown';
import { MultiLevelDropdown } from '../../../../../UI/MultiLevelDropdown';

// ICONS
import addGrey from '../../../../../../icons/add-grey.svg';
import addLightGrey from '../../../../../../icons/add-light-grey.svg';
// import { CheckmarkIcon } from '../../../CheckmarkIcon';

// IMAGES
import editIcon from '../../../../../../images/edit.png';
// import filterIcon from '../../../../../../images/filter.png';

import './ResolvedAlertsTable.less';

const { REACT_APP_BUILD_ENV } = config;

export const ResolvedAlertsTable = (props) => {
  const { resolvedEvents, updateResolvedEvents, filterOptions, resolutionOptions, theme } = props;
  const history = useHistory();
  const { building } = useParams();
  const { search } = useLocation();
  const { type, severity, identified, resolved, system, resolution, page } = queryString.parse(search);
  const [eventsCount, setEventsCount] = useState(0);
  const [alertForResolution, setAlertForResolution] = useState({});
  // const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);
  const [isCustomResolutionModalOpen, setIsCustomResolutionModalOpen] = useState(false);

  const getFilteredEvents = async () => {
    const filters = { is_resolved: true };

    if (type) {
      const optionObject = filterOptions.resolved_events.find((option) => option.value === type);
      if (optionObject) filters.name = optionObject.key;
    }

    if (severity) {
      const optionObject = filterOptions.severity_levels.find((option) => option.value === severity);
      if (optionObject) filters.severity_level = optionObject.key;
    }

    switch (identified) {
      case 'Last 24 hours':
        filters.start_timestamp__gte = moment().subtract(24, 'hours').utc().format();
        break;
      case 'Last 3 days':
        filters.start_timestamp__gte = moment().subtract(3, 'days').utc().format();
        break;
      case 'Last 7 days':
        filters.start_timestamp__gte = moment().subtract(7, 'days').utc().format();
        break;
      case 'Last 2 weeks':
        filters.start_timestamp__gte = moment().subtract(2, 'weeks').utc().format();
        break;
      case 'Last 1 month':
        filters.start_timestamp__gte = moment().subtract(1, 'months').utc().format();
        break;
      case 'All Time':
        filters.start_timestamp__gte = '';
        break;
      default:
        break;
    }

    switch (resolved) {
      case 'Last 24 hours':
        filters.end_timestamp__gte = moment().subtract(24, 'hours').utc().format();
        break;
      case 'Last 3 days':
        filters.end_timestamp__gte = moment().subtract(3, 'days').utc().format();
        break;
      case 'Last 7 days':
        filters.end_timestamp__gte = moment().subtract(7, 'days').utc().format();
        break;
      case 'Last 2 weeks':
        filters.end_timestamp__gte = moment().subtract(2, 'weeks').utc().format();
        break;
      case 'Last 1 month':
        filters.end_timestamp__gte = moment().subtract(1, 'months').utc().format();
        break;
      case 'All Time':
        filters.end_timestamp__gte = '';
        break;
      default:
        break;
    }

    if (system) {
      const optionObject = filterOptions.hvac_systems.find((option) => option.value === system);
      if (optionObject) filters.hvac_system = optionObject.key;
    }

    if (resolution) {
      const optionObject = filterOptions.resolutions.find((option) => option.value === resolution);
      if (optionObject) filters.resolutions = optionObject.key;
    }

    if (page) filters.page = page;

    const resolvedEventsFromApi = await getEventsList(REACT_APP_BUILD_ENV, building, filters);
    updateResolvedEvents(resolvedEventsFromApi.results);
    setEventsCount(resolvedEventsFromApi.count);
  };

  useEffect(() => {
    getFilteredEvents();
  }, [building, type, severity, identified, resolved, system, resolution, page]);

  const clearFilters = () => history.push(`/alerts/${building}?tab=Overview`);

  const clearTimeFilters = () => {
    let filtersUrl = '';

    // Add the already applied filters to the URL if there are any
    if (type) filtersUrl += `&type=${type}`;
    if (severity) filtersUrl += `&severity=${severity}`;
    if (system) filtersUrl += `&system=${system}`;
    if (resolution) filtersUrl += `&resolution=${resolution}`;

    history.push(`/alerts/${building}?tab=Overview${filtersUrl}`);
  };

  const applyFilter = async (filter, filterType) => {
    let filtersUrl = '';

    // Add the already applied filters to the URL if there are any
    if (type && filterType !== 'type') filtersUrl += `&type=${type}`;
    if (severity && filterType !== 'severity') filtersUrl += `&severity=${severity}`;

    if (identified && filterType === 'resolved') {
      filtersUrl += ''
    } else if (identified && filterType !== 'identified') filtersUrl += `&identified=${identified}`;
    
    if (resolved && filterType === 'identified') {
      filtersUrl += ''
    } else if (resolved && filterType !== 'resolved') filtersUrl += `&resolved=${resolved}`;

    if (system && filterType !== 'system') filtersUrl += `&system=${system}`;
    if (resolution && filterType !== 'resolution') filtersUrl += `&resolution=${resolution}`;

    // Add the selected filter to the URL
    switch (filterType) {
      case 'type':
        filtersUrl += `&type=${filter}`;
        break;
      case 'severity':
        filtersUrl += `&severity=${filter}`;
        break;
      case 'identified':
        filtersUrl += `&identified=${filter}`;
        break;
      case 'resolved':
        filtersUrl += `&resolved=${filter}`;
        break;
      case 'system':
        filtersUrl += `&system=${filter}`;
        break;
      case 'resolution':
        filtersUrl += `&resolution=${filter}`;
        break;
      case 'page':
        filtersUrl += `&page=${filter}`;
        break;
      default:
        break;
    }

    history.push(`/alerts/${building}?tab=Overview${filtersUrl}`);
  };

  // const checkIfResolutionSelected = (alert, resolutionOption) => {
  //   const { resolutions } = alert;
  //   let checked = false;

  //   // eslint-disable-next-line prefer-const
  //   for (let selectedResolution of resolutions) {
  //     if (selectedResolution.formatted_name === resolutionOption.formatted_name) {
  //       checked = true;
  //       break;
  //     }
  //   }

  //   return checked;
  // };

  // const updateResolution = async (resolutionOption) => {
  //   const { resolutions } = alertForResolution;
  //   const updatedResolutions = [];

  //   const removedResolution = resolutions.find(
  //     (alertResolution) => alertResolution.formatted_name === resolutionOption.formatted_name,
  //   );

  //   // Check if we are adding or removing the resolution
  //   if (removedResolution) {
  //     updatedResolutions.push({ name: null, slug: removedResolution.slug, is_removed: true });
  //   } else {
  //     updatedResolutions.push({ name: resolutionOption.formatted_name, slug: null, is_removed: false });
  //   }

  //   const response = await updateAlertResolutions(
  //     REACT_APP_BUILD_ENV,
  //     building,
  //     alertForResolution.incident_uid_hash,
  //     alertForResolution.uid_hash,
  //     updatedResolutions,
  //   );

  //   if (response === true) {
  //     // Handle success
  //     notification.info({
  //       className: `alerts-resolution-notification alerts-resolution-notification-${theme}`,
  //       placement: 'topRight',
  //       duration: 5,
  //       icon: <CheckmarkIcon theme={theme} />,
  //       message: 'Resolution successfully updated!',
  //     });

  //     getFilteredEvents();
  //   } else {
  //     notification.info({
  //       className: `alerts-resolution-notification alerts-resolution-notification-${theme}`,
  //       placement: 'topRight',
  //       duration: 5,
  //       icon: <CheckmarkIcon theme={theme} />,
  //       message: 'We encountered an error while trying to add this resolution. Please try again.',
  //     });
  //   }
  // };

  const onCustomResolutionSubmit = async () => {
    getFilteredEvents();
    setIsCustomResolutionModalOpen(false);
  };

  const getSeverityColour = (alert) => {
    if (alert.severity === 'high') return '#EA856F';
    if (alert.severity === 'medium') return '#DEC802';
    return '#796FEA';
  };

  const renderNoFilterResults = () => {
    return (
      <Empty
        description={
          <div className="alerts-overview-no-snoozed-alerts-content">
            <strong>No alerts found based on the selected filters</strong>
            <span
              className="alerts-overview-filters-clear"
              onClick={clearFilters}
              onKeyDown={clearFilters}
              role="button"
              tabIndex={0}
            >
              Clear Filters
            </span>
          </div>
        }
      />
    );
  };

  const renderResolutionMenu = () => {
    return [
      {
        key: 'Custom Resolutions',
        disabled: true,
        label: (
          <div style={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.3)' : '' }} role="presentation">
            Select Resolution(s)
          </div>
        ),
      },
      // ...resolutionOptions.map((resolutionOption, index) => {
      //   const checked = checkIfResolutionSelected(alert, resolutionOption);
      //   return ({
      //     key: `resolution-${index}`,
      //     label: (
      //       <div key={resolutionOption.name} className={`alerts-resolution-menu-item-checked-${checked}`}>
      //         <div
      //           className="alerts-resolution-menu-checkbox-container"
      //           role="presentation"
      //           onClick={() => updateResolution(resolutionOption)}
      //         >
      //           <Checkbox className={`app-checkbox-${theme}`} checked={checked} />
      //           {resolutionOption.formatted_name}
      //         </div>
      //       </div>
      //     ),
      //     }
      //   );
      // }),
      {
        key: 'Add Custom Resolution',
        label: (
          <div key="Custom resolution" className="alerts-resolution-menu-item-custom">
            <div
              className="alerts-resolution-menu-custom-container"
              role="presentation"
              onClick={() => setIsCustomResolutionModalOpen(true)}
            >
              {theme === 'light' ? (
                <img src={addGrey} alt="add button" className="alerts-resolution-menu-custom-button" />
              ) : (
                <img src={addLightGrey} alt="add button" className="alerts-resolution-menu-custom-button" />
              )}
              <span>Add Custom</span>
            </div>
          </div>
        ),
      },
    ];
  };

  const resolvedAlertsTableColumns = [
    {
      className: 'alerts-overview-table-column-type',
      title: 'ALERTS',
      dataIndex: ['type', 'severity'],
      render: (text, alert) => {
        const incidentId = alert.incident_uid_hash;
        const eventId = alert.uid_hash;
        const eventSeverity = alert.severity_display;
        const { start_timestamp: startTimestamp, end_timestamp: endTimestamp } = alert;
        return (
          <div className="alerts-overview-table-column-type-container">
            <div
              className="alerts-overview-table-column-type-colour"
              style={{ borderLeftColor: getSeverityColour(alert) }}
            />
            <div className="alerts-overview-table-column-type-contents">
              <span
                className="alerts-overview-item-title"
                onClick={() => history.push(`/alerts/${building}?incident_id=${incidentId}&event_id=${eventId}`)}
                onKeyDown={() => history.push(`/alerts/${building}?incident_id=${incidentId}&event_id=${eventId}`)}
                role="link"
                tabIndex={0}
              >
                {alert.name}
              </span>
              <div className="alerts-overview-table-column-container">
                <span className="alerts-overview-item-priority">Alert Tier: </span>
                <span className="alerts-overview-item-priority">{eventSeverity}</span>
              </div>
              <div className="alerts-overview-table-column-container mobile">
                <span>Identified: </span>
                <span className="alerts-overview-item-info">
                  {`${moment(startTimestamp).format('MMM D, YYYY (LT)')}`}
                </span>
              </div>
              <div className="alerts-overview-table-column-container mobile">
                <span>Resolved: </span>
                <span className="alerts-overview-item-info">
                  {`${moment(endTimestamp).format('MMM D, YYYY (LT)')}`}
                </span>
              </div>
              <div className="alerts-overview-table-column-container mobile">
                <span>System: </span>
                <span className="alerts-overview-item-info">{`${alert.hvac_system_display}`}</span>
              </div>
              <div className="alerts-overview-table-column-container mobile">
                <span>Resolution: </span>
                {alert.resolutions.length > 0 ? (
                  <div className="alerts-overview-item-resolutions-list">
                    {alert.resolutions.map((alertResolution) => {
                      return (
                        <span
                          key={`${alert.incident_uid_hash}-${alertResolution.slug}`}
                          className="alerts-overview-item-info"
                        >
                          {alertResolution.formatted_name}
                        </span>
                      );
                    })}
                    <Dropdown menu={() => renderResolutionMenu(alert)} trigger={['click']}>
                      <span
                        className="alerts-overview-item-resolution-button"
                        onClick={() => setAlertForResolution(alert)}
                        onKeyDown={() => setAlertForResolution(alert)}
                        role="button"
                        tabIndex={0}
                      >
                        Edit
                      </span>
                    </Dropdown>
                  </div>
                ) : (
                  <Dropdown menu={() => renderResolutionMenu(alert)} trigger={['click']}>
                    <span
                      className="alerts-overview-item-resolution-button"
                      onClick={() => setAlertForResolution(alert)}
                      onKeyDown={() => setAlertForResolution(alert)}
                      role="button"
                      tabIndex={0}
                    >
                      Add Resolution
                    </span>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    // Mobile Ends ^ - Desktop Begins v
    {
      title: 'IDENTIFIED DATE',
      dataIndex: 'start_timestamp',
      className: 'desktop',
      sorter: (a, b) => moment(a.start_timestamp) - moment(b.start_timestamp),
      render: (startTimestamp) => {
        return (
          <span className="alerts-overview-item-info">{`${moment(startTimestamp).format('MMM D, YYYY (LT)')}`}</span>
        );
      },
    },
    {
      title: 'END DATE',
      dataIndex: 'end_timestamp',
      className: 'desktop',
      sorter: (a, b) => moment(a.end_timestamp) - moment(b.end_timestamp),
      render: (endTimestamp) => {
        return (
          <span className="alerts-overview-item-info">{`${moment(endTimestamp).format('MMM D, YYYY (LT)')}`}</span>
        );
      },
    },
    {
      title: 'SYSTEM',
      dataIndex: 'hvac_system_display',
      className: 'desktop',
      render: (hvacSystem) => <span className="alerts-overview-item-info">{`${hvacSystem}`}</span>,
    },
    {
      title: 'RESOLUTION',
      dataIndex: ['type', 'resolutions'],
      className: 'alerts-overview-table-column-resolution desktop',
      render: (resolutions, alert) => {
        if (alert.resolutions.length > 0) {
          return (
            <div
              className="alerts-overview-item-resolutions"
              onClick={() => setAlertForResolution(alert)}
              onKeyDown={() => setAlertForResolution(alert)}
              role="button"
              tabIndex={0}
            >
              <div className="alerts-overview-item-resolutions-list">
                {alert.resolutions.map((alertResolution) => {
                  return (
                    <span
                      key={`${alert.incident_uid_hash}-${alertResolution.slug}`}
                      className="alerts-overview-item-info"
                    >
                      {alertResolution.formatted_name}
                    </span>
                  );
                })}
              </div>
              <Dropdown menu={{ items: renderResolutionMenu(alert) }} trigger={['click']}>
                {/* <Dropdown menu={() => renderResolutionMenu(alert)} trigger={['click']}> */}
                <div className="alerts-overview-item-resolutions-edit">
                  <img className="alerts-overview-item-resolutions-edit-icon" src={editIcon} alt="edit" />
                </div>
              </Dropdown>
            </div>
          );
        }
        return (
          // <Dropdown menu={() => renderResolutionMenu(alert)} trigger={['click']}>
          <Dropdown menu={{ items: renderResolutionMenu(alert) }} trigger={['click']}>
            <span
              className="alerts-overview-item-resolution-button"
              onClick={() => setAlertForResolution(alert)}
              onKeyDown={() => setAlertForResolution(alert)}
              role="button"
              tabIndex={0}
            >
              Add Resolution
            </span>
          </Dropdown>
        );
      },
    },
  ];

  const allTimeItems = [
    {
      label: 'All Time',
      callback: () => clearTimeFilters(),
    },
    {
      label: 'Identified Date',
      children: [
        {
          label: 'Last 24 hours',
          callback: () => applyFilter('Last 24 hours', 'identified'),
        },
        {
          label: 'Last 3 days',
          callback: () => applyFilter('Last 3 days', 'identified'),
        },
        {
          label: 'Last 7 days',
          callback: () => applyFilter('Last 7 days', 'identified'),
        },
        {
          label: 'Last 2 weeks',
          callback: () => applyFilter('Last 2 weeks', 'identified'),
        },
        {
          label: 'Last 1 month',
          callback: () => applyFilter('Last 1 month', 'identified'),
        },
      ],
    },
    {
      label: 'End Date',
      children: [
        {
          label: 'Last 24 hours',
          callback: () => applyFilter('Last 24 hours', 'resolved'),
        },
        {
          label: 'Last 3 days',
          callback: () => applyFilter('Last 3 days', 'resolved'),
        },
        {
          label: 'Last 7 days',
          callback: () => applyFilter('Last 7 days', 'resolved'),
        },
        {
          label: 'Last 2 weeks',
          callback: () => applyFilter('Last 2 weeks', 'resolved'),
        },
        {
          label: 'Last 1 month',
          callback: () => applyFilter('Last 1 month', 'resolved'),
        },
      ],
    },
  ];

  const renderFilters = () => {
    return (
      <>
        <PDropdown
          placeholder="All Past Alerts"
          items={filterOptions.resolved_events}
          title="value"
          callback={(c) => applyFilter(c.value, 'type')}
          theme={theme}
          filter={type}
        />
        <PDropdown
          placeholder="All Tiers"
          items={filterOptions.severity_levels}
          title="value"
          callback={(c) => applyFilter(c.value, 'severity')}
          theme={theme}
          filter={severity}
        />

        <MultiLevelDropdown
          placeholder="All time"
          items={allTimeItems}
          theme={theme}
          filter={[identified, resolved]}
        />
        <PDropdown
          placeholder="All Systems"
          items={filterOptions.hvac_systems}
          title="value"
          callback={(c) => applyFilter(c.value, 'system')}
          theme={theme}
          filter={system}
        />
        <PDropdown
          placeholder="All Resolutions"
          items={filterOptions.resolutions}
          title="value"
          callback={(c) => applyFilter(c.value, 'resolution')}
          theme={theme}
          filter={resolution}
        />
        {/* {(type || severity || identified || resolved || system || resolution) && (
          <span
            className="alerts-overview-filters-clear"
            onClick={clearFilters}
            onKeyDown={clearFilters}
            role="button"
            tabIndex={0}
          >
            Clear Filters
          </span>
        )} */}
      </>
    );
  };

  const paginationProperties = {
    className: 'alerts-overview-table-pagination',
    hideOnSinglePage: true,
    current: page || 1,
    pageSize: 12,
    showSizeChanger: false,
    total: eventsCount,
    showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} alerts`,
    onChange: (pageNumber) => applyFilter(pageNumber, 'page'),
  };

  return (
    <div className="alerts-overview-card">
      <div className="alerts-overview-card-header">
        <h1 className="alerts-overview-card-title">{`Past Alerts (${eventsCount})`}</h1>
        {/* <Button className="alerts-overview-export-button">
          Export
          <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.27857 4.28571H7.14286V0.714286C7.14286 0.321429 6.82143 0 6.42857 0H3.57143C3.17857 0 2.85714 0.321429 2.85714 0.714286V4.28571H1.72143C1.08571 4.28571 0.764286 5.05714 1.21429 5.50714L4.49286 8.78572C4.77143 9.06429 5.22143 9.06429 5.5 8.78572L8.77857 5.50714C9.22857 5.05714 8.91429 4.28571 8.27857 4.28571ZM0 11.4286C0 11.8214 0.321429 12.1429 0.714286 12.1429H9.28571C9.67857 12.1429 10 11.8214 10 11.4286C10 11.0357 9.67857 10.7143 9.28571 10.7143H0.714286C0.321429 10.7143 0 11.0357 0 11.4286Z"
              fill="#06B2BC"
            />
          </svg>
        </Button> */}
      </div>
      <div className="alerts-overview-filter-wrapper">
        <div className="alerts-overview-filters">
          {renderFilters()}
          {(type || severity || identified || resolved || system || resolution) && (
            <div
              className="alerts-overview-filters-clear"
              onClick={clearFilters}
              onKeyDown={clearFilters}
              role="button"
              tabIndex={0}
            >
              Clear Filters
            </div>
          )}
        </div>
      </div>
      
      <ConfigProvider renderEmpty={() => renderNoFilterResults()}>
        <Table
          className={`alerts-overview-table alerts-overview-table-resolved RAT-${theme}`}
          columns={resolvedAlertsTableColumns}
          dataSource={resolvedEvents}
          showSorterTooltip={false}
          pagination={paginationProperties}
        />
      </ConfigProvider>
      {isCustomResolutionModalOpen && (
        <CustomResolutionModal
          alertForResolution={alertForResolution}
          resolutionOptions={resolutionOptions}
          onCancel={() => setIsCustomResolutionModalOpen(false)}
          onSubmit={onCustomResolutionSubmit}
          theme={theme}
        />
      )}
    </div>
  );
};
